var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 desc p-4"},[_vm._v("Documentation Here")])
}
var staticRenderFns = []

export { render, staticRenderFns }